import axios from '@plugins/axios';

class UsuarioService {
    getList(params = {}, options = {}) {
        return axios({
            url: `operadora/usuario`,
            method: 'GET',
            params,
            ...options
        });
    }
    create(data) {
        return axios({
            url: `operadora/usuario`,
            method: 'POST',
            data
        });
    }
    update(id, data) {
        return axios({
            url: `operadora/usuario/${id}`,
            method: 'PUT',
            data
        })
    }
}

export const BaseUsuarioService = UsuarioService

export default new UsuarioService();